import { useEffect, useState } from "react";
import MaterialTable from "material-table";
import {
  Box,
  Button,
} from "@mui/material";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import ApprovalPopUp from "./ApprovalPopUp";
import { GetPendingApprovalAdjustmentExitEmployeesHelper, GetPendingApprovalClearanceExitEmployeesHelper } from "../../helper/AdminActionHelper";
import { toast } from "react-toastify";

const PendingApprovalEcmsPage = ({mode}) => {
  const [isLoading, setIsLoding] = useState(false);
  const [employeeData, setEmployeeData] = useState([])
  const [openPopup, setOpenPopup] = useState(false);
  const [employeeRecord, setEmployeeRecord] = useState(null);

  const fetchData = (modeValue) => {
    if(modeValue === '1') {
      setIsLoding(true);
      GetPendingApprovalClearanceExitEmployeesHelper({tab_type: 'Pending'}).then((res) => {
        setIsLoding(false);
        if(res?.data?.statuscode === 200) {
          setEmployeeData(res?.data?.data?.[0]?.fn_get_pending_approval_clearance_exit_employees)
        } else {
          toast.error("Something went wrong")
        }
      })
    }
    if(modeValue === '2') {
      setIsLoding(true);
      GetPendingApprovalAdjustmentExitEmployeesHelper({tab_type: 'Pending'}).then((res) => {
        setIsLoding(false);
        if(res?.data?.statuscode === 200) {
          setEmployeeData(res?.data?.data?.[0]?.fn_get_pending_approval_adjustment_exit_employees)
        } else {
          toast.error("Something went wrong")
        }
      })
    }
  }

  const closeMode = (fetch) => {
    setEmployeeRecord(null);
    setOpenPopup(false);
    if(fetch) {
      fetchData(fetch);
    }
  };

  useEffect(() => {
    fetchData(mode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEmployeeClicked =  (event, rowData) => {
    event.stopPropagation();
    setEmployeeRecord(rowData);
    setOpenPopup(true);    
  };
  return (
      <Box sx={{ height: "calc(100vh - 155px)", overflowY: "auto" }}>
        <Box>
          <MaterialTable
            isLoading={isLoading}
            columns={[
              {
                title: "Name",
                field: "employee_name",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
              },
              {
                field: "doj",
                title: "DOJ",
                render: (rowData) => ConvertDate(rowData?.doj),
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
              },
              {
                field: "resignation_date",
                title: "Resignation Date",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => ConvertDate(rowData?.resignation_date)
              },
              {
                field: "lwd",
                title: "Last Working Date",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => ConvertDate(rowData?.lwd)
              },
              {
                field: "exit_status",
                title: "Action",
                headerStyle: {
                  textAlign: "center",
                  padding: "5px 0px 5px 10px",
                },
                cellStyle: {
                  textAlign: "center",
                  padding: "7px 0px 7px 13px"
                },
                render: (rowData) => {
                  return (
                    <Button variant="text" height="38px" onClick={(event) => handleEmployeeClicked(event, rowData)}>
                      Take Action
                    </Button>
                  );
                },
              },
            ]}
            data={employeeData || []}
            options={{
              maxBodyHeight: "calc(100vh - 285px)",
              minBodyHeight: "calc(100vh - 285px)",
              rowStyle: {
                fontSize: "13px",
              },
              headerStyle: {
                padding: "7px 10px 7px 10px",
                fontWeight: "bold",
              },
              sorting: false,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
              showTitle: true,
              exportAllData: false,
              exportButton: false,
            }}
            title="Employee Awaiting Exit Approval"
          />
        </Box>
        <Popup
          title={`Employee Exit Approval`}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="sm"
        >
          <ApprovalPopUp
            setOpenPopup={setOpenPopup}
            employeeRecord={employeeRecord}
            closeMode={closeMode}
            mode={mode}
          />
        </Popup>
      </Box>
  );
};


export default PendingApprovalEcmsPage;
